import React, { useState } from 'react'
import NavBar from '../components/nav-bar/Nav'
import SideBar from '../components/Sidebar'
import Hero from '../components/Hero'
import { Projects } from '../data/HeroSpotlight'
import { Helmet } from 'react-helmet-async'

export default function HomePage() {
  const [isOpen, setIsOpen] = useState(false)
  const toggle = () => setIsOpen(!isOpen)

  return (
    <>
      <Helmet>
        <title>Vitalforce Capital</title>
      </Helmet>

      <SideBar $isopen={isOpen} toggle={toggle} />
      <NavBar toggle={toggle} />
      <Hero Projects={Projects} />
    </>
  )
}
